import { useEffect, useMemo, useState } from 'react';
import { useSnackbar } from 'notistack';
import {
  Box,
  Dialog,
  TextField,
  NativeSelect,
  Stack,
  Typography,
  styled,
  Button,
  FormHelperText,
  Alert,
} from '@mui/material';

import moment from 'moment';
import Iconify from '../../../../components/Iconify';
import conObj from '../../../../utils/connection-assistant';
import useLocales from '../../../../hooks/useLocales';
import { useDispatch, useSelector } from '../../../../redux/store';
import { openAddMemberBankDialog } from '../../../../redux/slices/addMemberBankDialog';
import { ThemeButton } from '../../../GlobalStyles';
import useCountdown from '../../../../hooks/useCountdown';
import PhonenumberTextField2 from '../../../../components/PhonenumberTextField2';
import uuidv4 from '../../../../utils/uuidv4';
import { OTPBanks } from '../../../../config';
import palette from '../../../../theme/palette';

const CloseButton = styled(Iconify)(({ theme }) => ({
  cursor: 'pointer',
  position: 'absolute',
  right: '16px',
  top: '16px',
  color: 'rgb(147, 172, 211)',
}));

const StyledInput = styled(TextField)(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  fontSize: 14,
  flexGrow: 1,
  width: '100%',
  marginTop: 8,
  '& input': {
    fontWeight: 600,
    '&::placeholder': {
      color: 'rgb(255, 255, 255, .3)',
    },
  },
}));

const InputWrapper = styled(Stack)(({ theme }) => ({
  background: palette.transactionDialog.withdraw.withdrawInputBox.bg,
  border: `1px solid ${palette.transactionDialog.withdraw.withdrawInputBox.border}`,
  borderRadius: '5px',
  padding: '4px 11px',
  // height: '42px',
  marginTop: 8,
  alignItems: 'center',
}));

const StyledSelect = styled(TextField)(({ theme }) => ({
  width: '100%',
  color: '#fff',
  fontWeight: 600,
  // padding: '4px 11px',
  mt: 8,
  border: '0.5px solid #FCD509',
  borderRadius: 8,
  '.MuiSvgIcon-root ': {
    fill: '#fff !important',
  },
}));

const StyledDialogLabel = styled(Typography)(({ theme }) => ({
  fontSize: '18px',
  color: 'white',
  fontWeight: 'bolder',
}));

const InputLable = styled(Typography)(({ theme }) => ({
  color: 'white',
}));

const StyledButton = styled(Button)({
  background: 'linear-gradient(180deg, #FEE504 0%, #ED7E40 100%)',
  boxShadow: '0px 0px 8px 0px #FFD633',
  border: '1px solid #FFF1B9',
  margin: 0,
  color: '#fff',
  '&:hover': {
    backgroundColor: '#fff',
    border: '1px solid #000',
  },
});

const RequiredField = () => <span style={{ color: 'red', marginRight: 5 }}>*</span>;

const InputError = ({ children }) => <span style={{ fontSize: '.75rem', color: 'red' }}>{children}</span>;

const WithdrawFormDialog = () => {
  const { enqueueSnackbar } = useSnackbar();

  const { translate } = useLocales();

  const dispatch = useDispatch();

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const { isAddMemberBankDialog } = useSelector((x) => x.addMemberBankDialog);

  const [bankList, setBankList] = useState([]);
  const [errors, setErrors] = useState([]);
  const [newBankAccountForm, setNewBankAccountForm] = useState({
    accountName: '',
    bank: '',
    accountNumber: '',
    // phoneNumber: '',
    // otpUuid: '',
    // otpCode: '',
  });

  // const [resendExpiry, setResendExpiry] = useState(null);

  // const resendCountdown = useCountdown(resendExpiry);

  // const isBankOTP = useMemo(() => {
  //   const bankFound = bankList.find((x) => x?.id === newBankAccountForm?.bank);

  //   if (OTPBanks.includes(bankFound?.code)) {
  //     return true;
  //   }

  //   return false;
  // }, [newBankAccountForm?.bank, bankList]);

  useEffect(() => {
    getBankList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewBankAccountForm((prevState) => ({ ...prevState, [name]: value }));
  };

  const getBankList = () => {
    conObj
      .post('transactions/supported_banks.json')
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.data?.status === 1) {
            setBankList(res.data?.data?.data?.[0]?.Bank || []);
          }
        }
      })
      .catch((err) => {
        console.log(`Server Error: ${err.message}`);
        enqueueSnackbar(err?.message, { variant: 'error', autoHideDuration: 5000 });
      });
  };

  // const onRequestOtp = async () => {
  //   if (isValid()) {
  //     setIsButtonDisabled(true);
  //     try {
  //       setResendExpiry(null);
  //       let fingerprint = localStorage.getItem('fingerprint');
  //       if (!fingerprint) {
  //         fingerprint = uuidv4();
  //         localStorage.setItem('fingerprint', fingerprint);
  //       }

  //       const response = await conObj.post('otp_request.json', {
  //         no_hp: `88${newBankAccountForm.accountNumber.replace(/[^0-9]/g, '')}`,
  //         fingerprint,
  //         purpose: 'addbankaccount',
  //       });

  //       setNewBankAccountForm((prev) => ({ ...prev, otpUuid: response.data?.data?.data?.otp_uuid }));
  //       setResendExpiry(moment().add(1, 'minute').toISOString());
  //     } catch (err) {
  //       console.log(`Error: ${err.message}`);
  //       const snackbarOptions = { variant: 'error', autoHideDuration: 5000 };
  //       enqueueSnackbar(err.message, snackbarOptions);
  //     } finally {
  //       setIsButtonDisabled(false);
  //     }
  //   }
  // };

  // const resendOtp = async () => {
  //   await onRequestOtp();
  // };

  const addMemberBank = () => {
    // if (!newBankAccountForm?.otpCode && isBankOTP) {
    //   setErrors((prev) => ({ ...prev, otpCode: translate('x_is_required', { x: translate('verification_code') }) }));
    //   return;
    // }

    setIsButtonDisabled(true);

    const requestData = {
      'member_bank-type': 'bank',
      'member_bank-bank_id': newBankAccountForm?.bank,
      'member_bank-account_name': newBankAccountForm?.accountName.trim(),
      'member_bank-account_number': newBankAccountForm?.accountNumber.trim(),
      // 'member_bank-bank_branch': newBankAccountForm?.bankBranch.trim(),
      // 'member_bank-pay_id': newBankAccountForm?.payID.trim(),
    };

    // if (isBankOTP) {
    //   requestData.otp_uuid = newBankAccountForm?.otpUuid;
    //   requestData.otp_code = newBankAccountForm?.otpCode;
    // }

    conObj
      .post('members/bank_add.json', requestData)
      .then((res) => {
        if (res.status === 200) {
          if (res.data?.data?.status === 1) {
            isAddMemberBankDialog?.onClose();

            dispatch(openAddMemberBankDialog({ open: false, onClose: null }));
          }
        }
      })
      .catch((err) => {
        setIsButtonDisabled(false);
        console.log(`Server Error: ${err.message}`);
        enqueueSnackbar(err?.message, { variant: 'error', autoHideDuration: 5000 });
      });
  };

  const isValid = () => {
    let valid = true;

    const _errors = {};

    if (!newBankAccountForm.accountName.trim()) {
      valid = false;
      _errors.accountName = translate('x_is_required', { x: translate('account_name') });
    } else if (newBankAccountForm.accountName.trim().length < 5) {
      valid = false;
      _errors.accountName = translate('account_name_must_be_4');
    } else {
      _errors.accountName = '';
    }

    if (!newBankAccountForm.bank) {
      valid = false;
      _errors.bank = translate('please_select_x', { x: translate('bank_account') });
    } else {
      _errors.bank = '';
    }

    const accNumberLenght = newBankAccountForm.accountNumber.trim().length;
    const selectedBank = bankList.find((f) => f.id === newBankAccountForm?.bank);

    if (!newBankAccountForm.accountNumber.trim()) {
      valid = false;
      _errors.accountNumber = translate('x_is_required', { x: translate('account_number') });
    } else if (parseInt(selectedBank?.min_length, 10) > 0 || parseInt(selectedBank?.max_length, 10) > 0) {
      if (parseInt(selectedBank?.min_length, 10) > 0 && accNumberLenght < parseInt(selectedBank?.min_length, 10)) {
        valid = false;
        _errors.accountNumber = translate('minimum_length_is_x', { x: selectedBank?.min_length });
      } else if (
        parseInt(selectedBank?.max_length, 10) > 0 &&
        accNumberLenght > parseInt(selectedBank?.max_length, 10)
      ) {
        valid = false;
        _errors.accountNumber = translate('maximum_length_is_x', { x: selectedBank?.max_length });
      } else {
        _errors.accountNumber = '';
      }
    } else {
      _errors.accountNumber = '';
    }

    // phone number
    // if (!newBankAccountForm?.phoneNumber.trim()) {
    //   valid = false;
    //   _errors.phoneNumber = translate('x_is_required', { x: translate('phone_number') });
    // } else if (
    //   process.env.REACT_APP_MOBILENUMBER_MIN_LENGTH &&
    //   newBankAccountForm?.phoneNumber.trim().length < Number(process.env.REACT_APP_MOBILENUMBER_MIN_LENGTH) + 3
    // ) {
    //   valid = false;
    //   _errors.phoneNumber = translate(`invalid_x_must_be_atleast_y_characters`, {
    //     x: translate('phone_number'),
    //     y: process.env.REACT_APP_MOBILENUMBER_MIN_LENGTH,
    //   });
    // } else if (
    //   process.env.REACT_APP_MOBILENUMBER_MAX_LENGTH &&
    //   newBankAccountForm?.phoneNumber.trim().length > Number(process.env.REACT_APP_MOBILENUMBER_MAX_LENGTH) + 3
    // ) {
    //   valid = false;
    //   _errors.phoneNumber = translate('phone_num_x_max', { x: process.env.REACT_APP_MOBILENUMBER_MAX_LENGTH });
    // } else {
    //   _errors.phoneNumber = '';
    // }

    setErrors(_errors);

    return valid;
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      sx={{ minHeight: 500 }}
      PaperProps={{
        sx: {
          backgroundColor: '#252631',
        },
      }}
      className="modal-container container-no-scrollbar"
      open={isAddMemberBankDialog?.open}
      onClose={() => dispatch(openAddMemberBankDialog({ open: false, onClose: null }))}
    >
      {/* Title */}
      <Box sx={{ pt: 3, px: 3, background: '#252631' }}>
        <StyledDialogLabel>{translate('withdraw_information')}</StyledDialogLabel>
        <CloseButton
          icon={'ep:close'}
          width={24}
          height={24}
          onClick={() => dispatch(openAddMemberBankDialog({ open: false, onClose: null }))}
        />
      </Box>

      <Box sx={{ p: 3 }}>
        {!newBankAccountForm?.otpUuid ? (
          <>
            <Box sx={{ mb: '10px' }}>
              <Stack direction="row" alignItems={'center'}>
                <InputLable>
                  <RequiredField />
                  {translate('bank')}
                </InputLable>
              </Stack>

              <StyledSelect
                fullWidth
                select
                SelectProps={{ native: true }}
                name="bank"
                value={newBankAccountForm?.bank}
                onChange={(e) => handleChange(e)}
                disableUnderline={true}
              >
                <option value="" />
                {bankList?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </StyledSelect>
              {errors?.bank && <InputError>{errors?.bank}</InputError>}
            </Box>

            <Box sx={{ mb: '10px' }}>
              <Stack direction="row" alignItems={'center'}>
                <InputLable>
                  <RequiredField />
                  {translate('account_holder_name')}
                </InputLable>
              </Stack>

              <StyledInput
                value={newBankAccountForm.accountName}
                name="accountName"
                onChange={(e) => handleChange(e)}
                placeholder={translate('name_of_the_account_holder')}
              />
              {errors?.accountName && <InputError>{errors?.accountName}</InputError>}
            </Box>

            <Box sx={{ mb: '10px' }}>
              <Stack direction="row" alignItems={'center'}>
                <InputLable>
                  <RequiredField />
                  {translate('account_number')}
                </InputLable>
              </Stack>

              <StyledInput
                value={newBankAccountForm?.accountNumber}
                name="accountNumber"
                onChange={(e) => handleChange(e)}
                placeholder={translate('fill_in_bank_account')}
              />

              {errors?.accountNumber && <InputError>{errors?.accountNumber}</InputError>}
            </Box>

            {/* <Box sx={{ mb: '10px' }}>
              <Stack direction="row" alignItems={'center'}>
                <InputLable>
                  <RequiredField />
                  {translate('phone_number')}
                </InputLable>
              </Stack>

              <PhonenumberTextField2
                name="phoneNumber"
                value={newBankAccountForm?.phoneNumber}
                placeholder={translate('fill_in_phone_number')}
                onChange={(e) => handleChange({ target: { value: e, name: 'phoneNumber' } })}
                fullWidth
                InputPropStyles={{
                  border: '1px solid yellow',
                  borderRadius: 1,
                  fontWeight: 700,
                  mt: '8px',
                  '& input': {
                    fontSize: '1rem',
                    '&::placeholder': {
                      fontSize: '1rem',
                      color: 'rgb(255, 255, 255, .3)',
                    },
                  },
                }}
              />

              {errors?.phoneNumber && <InputError>{errors?.phoneNumber}</InputError>}
            </Box> */}
          </>
        ) : (
          <>
            <Alert severity="success" sx={{ mb: 1 }}>
              {translate('otp_sent')}
            </Alert>
            <Box sx={{ mb: '10px' }}>
              <Stack direction="row" alignItems={'center'}>
                <InputLable>
                  <RequiredField />
                  {translate('verification_code')}
                </InputLable>
              </Stack>

              <StyledInput
                value={newBankAccountForm?.otpCode}
                name="otpCode"
                onChange={(e) => handleChange(e)}
                placeholder={translate('input_otp')}
              />
              {errors?.otpCode && <InputError>{errors?.otpCode}</InputError>}

              {/* <Box sx={{ display: 'flex', mb: 2 }}>
                {resendCountdown?.seconds !== '00' ? (
                  <>
                    <FormHelperText>{translate('send_again_in_x', { x: resendCountdown.seconds })}</FormHelperText>
                  </>
                ) : (
                  <>
                    <FormHelperText
                      sx={{ textDecoration: 'underline', fontWeight: 900, cursor: 'pointer' }}
                      onClick={!isButtonDisabled ? () => resendOtp() : null}
                    >
                      {translate('send_again')}
                    </FormHelperText>
                  </>
                )}
              </Box> */}
            </Box>
          </>
        )}

        <ThemeButton
          onClick={() => {
            setErrors({});
            // if (!newBankAccountForm?.otpUuid && isBankOTP) onRequestOtp();
            addMemberBank();
          }}
          disabled={isButtonDisabled}
          loading={isButtonDisabled}
          sx={{
            width: '100%',
            height: '42px',
            fontSize: '17px',
            fontFamily: 'sans-serif',
            marginTop: '20px',
          }}
        >
          {translate('save')}
          {/* {translate(newBankAccountForm?.otpUuid ? 'save' : 'next')} */}
        </ThemeButton>
      </Box>
    </Dialog>
  );
};

export default WithdrawFormDialog;
